import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'app/components/shared.module';
import { PipesModule } from 'app/pipes/pipes.module';
import { DeviceRepository } from 'app/services/database/device.repository';
import { DevicesGroupRepository } from 'app/services/database/devicesGroup.repository';
import { DeviceService } from 'app/services/device.service';
import { DevicesGroupService } from 'app/services/devicesGroup.service';
import { DevicesListComponent } from 'app/views/devices/devicesList.component';
import { EditDeviceComponent } from 'app/views/devices/editDevice.component';
import { EditScheduleComponent } from 'app/views/devices/editSchedule/editSchedule.component';
import { EditScheduleEntriesComponent } from 'app/views/devices/editScheduleEntries/editScheduleEntries.component';
import { EditTimezoneComponent } from 'app/views/devices/editTimezone/editTimezone.component';
import { DevicesGroupsListComponent } from 'app/views/devices/groups/devicesGroupsList.component';
import { EditDevicesGroupComponent } from 'app/views/devices/groups/editDevicesGroup.component';
import { TimezonePickerModule } from 'ng2-timezone-selector';
import { LinkDeviceComponent } from './linkDevice.component';
import { WebViewComponent } from './web-view/web-view.component';

@NgModule({
    imports: [
        BrowserModule,
        PipesModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        TranslateModule,
        TimezonePickerModule
    ],
    exports: [
        LinkDeviceComponent,
        DevicesListComponent,
        EditScheduleEntriesComponent,
        EditDeviceComponent,
        EditTimezoneComponent,
        EditScheduleComponent,
        DevicesGroupsListComponent,
        EditDevicesGroupComponent,
        WebViewComponent
    ],
    declarations: [
        LinkDeviceComponent,
        DevicesListComponent,
        EditScheduleEntriesComponent,
        EditDeviceComponent,
        EditTimezoneComponent,
        EditScheduleComponent,
        DevicesGroupsListComponent,
        EditDevicesGroupComponent,
        WebViewComponent
    ],
    providers: [
        DeviceService,
        DevicesGroupService,
        DeviceRepository,
        DevicesGroupRepository
    ]
})
export class DevicesModule {

    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: DevicesModule,
            providers: [
                DeviceService,
                DeviceRepository
            ]
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/views/devices/devices.module.ts